import { useCallback } from 'react';
import type { Alert } from '@apos/shared';
import { api, errorMessage } from '../../lib/api';
import { toast } from '../../components/ui';
import { useMission } from '../../state/mission';

/** Acknowledge alerts for the current user; folds the updated alerts into the store immediately. */
export function useAckAlerts() {
  const missionId = useMission((s) => s.missionId);
  return useCallback(
    async (alerts: readonly Alert[]) => {
      if (!missionId || !alerts.length) return;
      const results = await Promise.allSettled(alerts.map((a) => api.alerts.ack(missionId, a.id)));
      const ok = results.flatMap((r) => (r.status === 'fulfilled' && r.value ? [r.value] : []));
      if (ok.length) useMission.getState().ingest(ok.map((data) => ({ type: 'alert' as const, data })));
      const failed = results.find((r) => r.status === 'rejected');
      if (failed && failed.status === 'rejected') toast({ title: 'Could not acknowledge', body: errorMessage(failed.reason), tone: 'alert' });
    },
    [missionId],
  );
}
